import { getXRModule } from './xrModule.js';
export const xrStore = getXRModule().createXRStore({
    handTracking: true,
    emulate: false,
});
//# sourceMappingURL=xrStore.js.map